import React, { Component } from 'react';

class DireccionExistente extends Component {
    render() { 

        const {data} = this.props;
        let mensaje = null;
        let mailPrepaga = data.emailCuentasActuales.TP ? data.emailCuentasActuales.TP.Contacto : null; 
        let mailCredito = data.emailCuentasActuales.TC ? data.emailCuentasActuales.TC.Contacto : null; 

        if(data.checkProductoPrepaga && data.checkProductoCredito) mensaje = "las cuentas a...?"
        else if(data.checkProductoPrepaga) mensaje = "la cuenta prepaga a...?"
        else if(data.checkProductoCredito) mensaje = "la cuenta crédito a...?"
    
        return (  
            <div className='modaDireccionExistenteInterior'>
            <div className='modalDireccionExistenteHeader'>
                <div>¡Atención!</div>
                <label onClick={()=>this.props.funcionCancelar("EMAIL",true)} className='ti-close clickable'></label>
            </div>
            <div className='modalDireccionExistenteBody'>
                {data.checkProductoPrepaga && mailPrepaga && <div className='modalDireccionExistenteBodyText'>La cuenta prepaga tiene asociada la siguiente dirección electrónica</div>}
                {data.checkProductoPrepaga && mailPrepaga && <div>{mailPrepaga}</div>}
                {data.checkProductoCredito && mailCredito && <div className='modalDireccionExistenteBodyText'>La cuenta crédito tiene asociada la siguiente dirección electrónica</div>}
                {data.checkProductoCredito && mailCredito && <div>{mailCredito}</div>}  
                {<div className='modalDireccionExistenteBodyText'>{"¿Desea cambiar la dirección electrónica de " + mensaje}</div>} 
                <div>{data.emailEnEdicion}</div>             
            </div>
            
            <div className='footerTelefonosModal'>
                <button onClick={()=>this.props.funcionCancelar("EMAIL",true)} className='btn btn-secondary'>Cancelar</button>{/*VUELVE AL MODAL DE ALTA DE MAIL*/}
                <button onClick={()=>this.props.funcionAceptar("EMAIL")} className='btn btn-cta'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default DireccionExistente;